/* src/app/front-layout/front-layout.component.css */
test-list {
  display: flex;
  gap: 20px;
  margin: 20px;
  overflow-x: auto;
  padding-bottom: 10px;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
}
@media (max-width: 768px) {
  .test-list {
    flex-direction: column;
  }
}
/*# sourceMappingURL=front-layout.component.css.map */
